<template>
  <PageWrapper :isLoading="isLoading" isChildWrapper>
    <template #title> تماس از طرف استاد </template>
    <BRow>
      <BCol cols="6">
        <CustomAppendText
          :isText="true"
          customRules="required|min:1"
          inputId="callUnitPrice"
          inputLabel="قیمت هر ده دقیقه تماس استاد با زبان آموز"
          inputPlaceholder="5000 تومان"
          v-model="callUnitPrice"
        >
          <template #append> تومان </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12" class="d-flex align-items-center justify-content-end">
        <BButton
          variant="success"
          @click="renderEditCallPriceConfirmationModal"
        >
          ویرایش قیمت
        </BButton>
      </BCol>
    </BRow>
    <EditCallPriceConfirmationModal
      :isOkButtonDisabled="isLoading"
      @updateCallPrice="updateDefaultCallUnitPrice"
    ></EditCallPriceConfirmationModal>
  </PageWrapper>
</template>

<script>
export default {
  props: {
    isDense: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  mounted() {
    this.getDefaultCallUnitPrice();
  },
  data() {
    return {
      isLoading: false,
      callUnitPrice: null,
    };
  },
  methods: {
    renderEditCallPriceConfirmationModal() {
      this.$bvModal.show("edit-call-price-confirmation-modal");
    },
    closeEditCallPriceConfirmationModal() {
      this.$bvModal.hide("edit-call-price-confirmation-modal");
    },
    async updateDefaultCallUnitPrice() {
      try {
        this.isLoading = true;
        let _this = this;

        let setCallPriceUnit = new SetCallPriceUnit(_this);
        setCallPriceUnit.setRequestParam({ unitPrice: _this.callUnitPrice });
        await setCallPriceUnit.fetch((response) => {
          if (response.isSuccess) {
            _this.getDefaultCallUnitPrice();
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: "ویرایش شد",
                icon: "MessageIcon",
                variant: "success",
                text: "قیمت ده دقیقه تماس با موفقیت ویرایش شد.",
              },
            });
            _this.closeEditCallPriceConfirmationModal();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text:
                  response.message || "مشکلی پیش آمد، لطفا دوباره امتحان کنید.",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getDefaultCallUnitPrice() {
      try {
        this.isLoading = true;
        let _this = this;

        let getCallPriceUnit = new GetCallPriceUnit(_this);
        await getCallPriceUnit.fetch((response) => {
          if (response.isSuccess) {
            this.callUnitPrice = response.data;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    CustomAppendText,
    EditCallPriceConfirmationModal,
    BRow,
    BCol,
    BButton,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import EditCallPriceConfirmationModal from "@/views/components/SiteSettings/EditCallPriceConfirmationModal.vue";
import { GetCallPriceUnit, SetCallPriceUnit } from "@/libs/Api/SiteSetting";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BRow, BCol, BButton } from "bootstrap-vue";
</script>
